import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';

import Vue from 'vue'


const getDefaultStateForProducts= () => {
  return {
    default_uom:"",
    products: [],
    uom_list:[],
    filter:{
      keyword:"",
      active_only:"1"
    },
    product_data:{
      code:"",
      name:"",
      is_sold:1,
      is_purchase:1,
      is_inventorized:1,
      base_uom:"",
      desp:"",
      desp_long:"",
      brand:"",
      model:"",
      sale_list_price:null,
      moq:"",
      is_active:1,
      category_items:[],
      product_codes:[],
      medias:[]
    },
    product_categories:[],
    tradeitem_desp_list:[],
    product_price:{},
    product_purchase_price:{},
    is_created:null,
    is_updated:null,
    is_deleted:null
  }
}


// state
const state = getDefaultStateForProducts()

// getters
const getters = {

}

// mutations
const mutations = {
    RESET_STATE_FOR_PRODUCTS (state) {
        Object.assign(state, getDefaultStateForProducts())
    },
    SET_DEFAULT_UOM(state, data) {
      state.default_uom = data
    },
    FETCH_TRADE_ITEM_DESP_LIST (state, list)
    {
        state.tradeitem_desp_list = list
    },
    FETCH_ALL(state, data){
      state.products = data
    },
    FETCH_PRODUCT_PURCHASE_PRICE(state, data) {
      state.product_purchase_price = data
    },
    FETCH_PRODUCT_PRICE(state, data) {
      state.product_price = data
    },
    FETCH_ALL_CATEGORIES(state, data){
      state.product_categories = data
    },
    SET_FILTER(state, data)
    {
      state.filter = data
    },
    SET_IS_CREATED(state, data)
    {
      state.is_created = data
    },
    SET_IS_UPDATED(state, data)
    {
      state.is_updated = data
    },
    SET_IS_DELETED(state, data)
    {
      state.is_deleted = data
    },
    QUICK_SEARCH(state, data){

      if(data)
      {
        data.forEach(function (element) {
            element.sale_list_price_display = (element.sale_list_price != null && element.sale_list_price != '') ? (element.sale_list_price * 1).toFixed(4): '-'
            element.moq = (element.moq != null && element.moq != '') ? (element.moq * 1).toFixed(4): '-'
            element.base_uom = (element.base_uom != null && element.base_uom != '') ? (element.base_uom) : '-'
        });
        state.products = data

      }

    },
    FETCH(state, data){
      state.product_data = data
    },
    FETCH_UOM_LIST(state, data){
      state.uom_list = data
    }
}

// actions
const actions = {
    getDefaultUOM({ commit }, data) {
      return axios.post(apiRoutes['GET_PRODUCT_DEFAULT_UOM'], data, authHeader())
          .then(response => {
            if(response.data.code == 1){
              commit('SET_DEFAULT_UOM', response.data.data.default_uom)
            } else {
              commit('SET_DEFAULT_UOM', null)
            }
          })
          .catch(error => {
            if (error.response) {
              console.log(error.response)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
    },
    resetState({ commit, dispatch }, payload) {
      commit("RESET_STATE_FOR_PRODUCTS")
    },
    async findTradeItemDesp({commit, dispatch}, data)
    {
        return axios.post(apiRoutes["TRADE_ITEM_DESP_LOOKUP"], data, authHeader()).then((response) => {
          if (response.data.code == 1) 
          {
            commit('FETCH_TRADE_ITEM_DESP_LIST', response.data.data);
          } 
          else 
          {
            commit('FETCH_TRADE_ITEM_DESP_LIST',[]);
          }
        })
        .catch((error) => 
        {
          if (error.response) 
          {
            Vue.notify({
              group: "notify",
              type: "error",
              text: error.response.data.msg,
              max: 5,
              duration: 5000,
              speed: 300,
            });
          } 
          else 
          {
            console.log("Problem Querying Data", error);
          }
        });
    },
    async create({ commit, dispatch }, data) {
      await axios
          .post(apiRoutes['PRODUCT_CREATE'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                  let doc_number  = response.data.data.code
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: 'Product (' + doc_number + ')' + " has been created!",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                  commit('SET_IS_CREATED', 1);
            }
            else
            {
                let errors = response.data.data.errors

                if(Array.isArray(errors))
                {
                  console.log(errors)
                  let msg = errors.join("\n")

                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }
              commit('SET_IS_CREATED', 0);

            }

          })
          .catch((error) => {
              // alert(error)
              // console.log(error.response)
              commit('SET_IS_CREATED', 0);

              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Application Error")
              }
          });
    },
    async update({ commit, dispatch }, data) {
      await axios
          .post(apiRoutes['PRODUCT_UPDATE'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                  let doc_number  = response.data.data.code
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: 'PRODUCT (' + doc_number + ')' + " has been updated!",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                  commit('SET_IS_UPDATED', 1);

            }
            else
            {
                let errors = response.data.data.errors

                if(Array.isArray(errors))
                {
                  console.log(errors)
                  let msg = errors.join("\n")

                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }

                commit('SET_IS_UPDATED', 0);


            }

          })
          .catch((error) => {
              // alert(error)
              // console.log(error.response)

              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Application Error")
              }
          });
    },
    async delete({ commit, dispatch }, data) {
      await axios.post(apiRoutes['PRODUCT_DELETE'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                  let doc_number  = response.data.data.code
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: 'PRODUCT (' + doc_number + ')' + " has been deleted!",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                  commit('SET_IS_DELETED', 1);
            }
            else
            {
                let errors = response.data.data.errors

                if(Array.isArray(errors))
                {
                  console.log(errors)
                  let msg = errors.join("\n")

                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }
                commit('SET_IS_DELETED', 0);


            }

          })
          .catch((error) => {

              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Problem Deleting Product")
              }
          });
    },
    fetch({ commit }, data) {
      return axios.post(apiRoutes['RETRIEVE_PRODUCT'], data, authHeader())
          .then(response => {
            if(response.data.code == 1)
            {
              commit('FETCH', response.data.data)
            } else {
              commit('FETCH', {})
            }
          })
          .catch(error => {
            if (error.response) {
              console.log(error.response)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
   },
    fetchAllCategories({ commit }, data) {
      return axios.post(apiRoutes['PRODUCT_CATEGORIES_LIST_ALL'], data, authHeader())
          .then(response => {
            if(response.data.code == 1){
              commit('FETCH_ALL_CATEGORIES', response.data.data)
            } else {
              commit('FETCH_ALL_CATEGORIES', [])
            }
          })
          .catch(error => {
            if (error.response) {
              console.log(error.response)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
  },
    listUoms({ commit }, data) {
        return axios.post(apiRoutes['LIST_PRODUCT_UOMS'], data, authHeader())
            .then(response => {
              if(response.data.code == 1){
                commit('FETCH_UOM_LIST', response.data.data)
              } else {
                commit('FETCH_UOM_LIST', [])
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
    },
   fetchProductPrice({ commit }, data) {
      return axios.post(apiRoutes['PRODUCT_GET_PRICE'], data, authHeader())
          .then(response => {
            if(response.data.code == 1)
            {
              commit('FETCH_PRODUCT_PRICE', response.data.data)
            } 
            else 
            {
              commit('FETCH_PRODUCT_PRICE', {})
            }
          })
          .catch(error => {
            if (error.response) {
              console.log(error.response)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
    },
    fetchProductPurchasePrice({ commit }, data) {
      return axios.post(apiRoutes['PRODUCT_GET_PURCHASE_PRICE'], data, authHeader())
          .then(response => {
            if(response.data.code == 1)
            {
              commit('FETCH_PRODUCT_PURCHASE_PRICE', response.data.data)
            } 
            else 
            {
              commit('FETCH_PRODUCT_PURCHASE_PRICE', {})
            }
          })
          .catch(error => {
            if (error.response) {
              console.log(error.response)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
    },
    
  quickSearch({ commit }, data) {
    return axios.post(apiRoutes['PRODUCT_QUICK_SEARCH'], data, authHeader())
        .then(response => {
          if(response.data.code == 1){
            commit('QUICK_SEARCH', response.data.data)
            commit('SET_FILTER', data)

          } else {
            commit('QUICK_SEARCH', [])
            commit('SET_FILTER', data)

          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response)
              Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: error.response.data.msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
          } else {
              console.log("Problem submitting New Post", error);
          }
      });
  },
}

export {
    state,
    getters,
    actions,
    mutations
}
